// AKSU Business School Official Portal Data
// Domain: businessschool.aksu.edu.ng
// British English throughout

export const INSTITUTION_INFO = {
  name: "Akwa Ibom State University Business School",
  shortName: "AKSU Business School",
  acronym: "AIBS",
  parentUniversity: "Akwa Ibom State University",
  domain: "businessschool.aksu.edu.ng",
  officialUrl: "https://businessschool.aksu.edu.ng",
  motto: "Knowledge · Enterprise · Leadership",
  universityMotto: "Knowledge & Technology for Development",
  established: "Executive School Established Under Akwa Ibom State University Law",
  viceChancellor: "Prof. Nse Essien",
  director: {
    name: "Dr Uwem Etim Uwah",
    title: "Acting Director, AKSU Business School",
    qualifications: "PhD, FCA, ACTI",
    fellowship: "Fellow, Institute of Chartered Accountants of Nigeria (ICAN)",
    department: "Department of Accounting",
    email: "uwemuwah@aksu.edu.ng",
    phone: "+234 803 338 0401",
    message: "Welcome to the Akwa Ibom State University Business School (AKSU Business School). Our executive programmes are designed with deliberate academic rigour and executive relevance to equip visionary captains of industry, heads of public sector MDAs, corporate managers, and emerging entrepreneurs with transformative leadership capabilities. Situated in Akwa Ibom State—the rising commercial, energy, and industrial hub of the Gulf of Guinea—our school blends world-class research with pragmatic executive case studies, delivered via weekend executive modules tailored for the schedules of senior working professionals."
  },
  contacts: {
    generalEmail: "aisubs@aksu.edu.ng",
    directorEmail: "uwemuwah@aksu.edu.ng",
    phoneWhatsApp: "+234 803 338 0401",
    phoneVoice: "+234 701 255 0607",
    admissionsHelpline: "+234 803 338 0401",
    social: {
      linkedin: "https://www.linkedin.com/company/aksu-business-school",
      facebook: "https://www.facebook.com/aksu-business-school"
    },
    campuses: [
      {
        name: "Main Campus (Business School Headquarters)",
        address: "Ikot Akpaden, Mkpat Enin Local Government Area, Akwa Ibom State, Nigeria",
        focus: "Executive Business School Directorate, Multimedia Amphitheatres, Doctoral Suites & University Senate"
      }
    ]
  },
  campusLocation: "Main Campus in Ikot Akpaden, Mkpat Enin, Akwa Ibom State",
  campuses: [
    {
      name: "Main Campus (Business School Headquarters)",
      type: "Primary Academic & Executive Campus",
      location: "Ikot Akpaden, Mkpat Enin LGA, Akwa Ibom State",
      description: "The definitive home and headquarters of Akwa Ibom State University Business School. Houses the modern executive amphitheatres, doctoral research libraries, departmental colloquium suites, and central administrative directorate with uninterrupted power and high-speed fiber connectivity.",
      features: [
        "Executive Multimedia Amphitheatres",
        "Doctoral Research & Advisory Suites",
        "Ultra-Modern E-Library & Information Repository",
        "Executive Boardroom Suites & Lounge",
        "24/7 Uninterrupted Power & High-Speed Optic Fiber",
        "Simultaneous Hybrid Broadcasting Studios"
      ]
    }
  ],
  accreditations: [
    "Full Accreditation by National Universities Commission (NUC)",
    "Institute of Chartered Accountants of Nigeria (ICAN) Strategic Partnership",
    "Chartered Institute of Bankers of Nigeria (CIBN) Professional Alliance",
    "Nigerian Institute of Management (NIM - Chartered) Accredited Training Partner"
  ],
  academicYear: "2025/2026 Executive Academic Session",
  nextIntake: "October 2026 commencement (Full-time/Virtual/Hybrid)",
  applicationFee: 25000, // NGN 25,000
  acceptanceFee: 50000 // NGN 50,000
};

export const DEPARTMENTS_AND_PROGRAMMES = [
  {
    id: "business-admin",
    name: "Business Administration",
    description: "Executive strategic management, entrepreneurial leadership, enterprise governance, and global commerce.",
    programmes: [
      {
        id: "phd-ba",
        degree: "PhD",
        name: "Doctor of Philosophy in Business Administration",
        duration: "3 - 5 Years (Executive Research Track)",
        mode: "Weekend Seminars & Dissertation Research",
        feePerSession: "₦850,000",
        category: "Doctoral",
        description: "An intensive research doctorate targeted at top researchers, policy advisers, and corporate strategists seeking to advance frontier scholarship in strategic management.",
        requirements: "A recognised Master's degree (M.Sc. or MBA with research thesis) in Business Administration or closely related discipline with minimum 3.50 CGPA on a 5.0 scale."
      },
      {
        id: "dba",
        degree: "DBA",
        name: "Doctor of Business Administration",
        duration: "3 Years (Practitioner Executive Track)",
        mode: "Modular Executive Weekends & Applied Industry Thesis",
        feePerSession: "₦950,000",
        category: "Doctoral",
        description: "A prestigious professional doctorate for C-suite executives, directors, and permanent secretaries focusing on applied organisational problem-solving and industry innovation.",
        requirements: "A Master's degree in any discipline from a recognised university, plus at least 5 years of senior executive management experience."
      },
      {
        id: "mba",
        degree: "MBA",
        name: "Master of Business Administration",
        duration: "18 - 24 Months",
        mode: "Executive Hybrid (Alternate Weekends + Digital LMS)",
        feePerSession: "₦550,000",
        category: "Master's",
        description: "Flagship executive master's programme building 360-degree leadership, financial acumen, strategic marketing, and corporate operational agility.",
        requirements: "A good first degree in any discipline from a recognised university, plus at least 3 years of public or private service experience; or a recognised Postgraduate Diploma."
      },
      {
        id: "pgd-ba",
        degree: "PGD",
        name: "Postgraduate Diploma in Business Administration",
        duration: "12 Months (2 Semesters)",
        mode: "Weekend Intensive",
        feePerSession: "₦320,000",
        category: "Postgraduate Diploma",
        description: "Bridge programme providing comprehensive foundation in corporate management, quantitative methods, and managerial economics for university graduates and HND holders.",
        requirements: "A third-class university degree, or a Higher National Diploma (HND) with minimum Upper/Lower Credit from a recognised polytechnic in a relevant discipline."
      },
      {
        id: "dip-ba",
        degree: "Diploma",
        name: "Diploma in Business Administration",
        duration: "18 Months",
        mode: "Part-Time Executive Track",
        feePerSession: "₦220,000",
        category: "Diploma",
        description: "Practical diploma programme developing core business competencies, operational bookkeeping, and customer service delivery.",
        requirements: "Senior Secondary School Certificate (SSCE/NECO/GCE) with at least five credit passes including English Language and Mathematics."
      },
      {
        id: "cert-ba",
        degree: "Certificate",
        name: "Certificate in Business Administration",
        duration: "6 Months",
        mode: "Executive Masterclasses",
        feePerSession: "₦140,000",
        category: "Certificate",
        description: "Fast-track executive skills acquisition course for supervisors, business owners, and unit leaders.",
        requirements: "SSCE with credit passes, or relevant corporate working experience subject to admissions board interview."
      }
    ]
  },
  {
    id: "public-admin",
    name: "Public Administration",
    description: "Public policy analysis, strategic governance, MDA leadership, civil service reform, and diplomatic protocol.",
    programmes: [
      {
        id: "dpa",
        degree: "DPA",
        name: "Doctor of Public Administration",
        duration: "3 Years",
        mode: "Executive Research & Policy Capstone",
        feePerSession: "₦900,000",
        category: "Doctoral",
        description: "Terminal executive degree for senior civil servants, legislators, development partners, and public policy practitioners.",
        requirements: "Master's degree in Public Administration, Political Science, International Relations or related discipline."
      },
      {
        id: "empa",
        degree: "EMPA",
        name: "Executive Master of Public Administration",
        duration: "18 Months",
        mode: "Weekend Seminars & Policy Labs",
        feePerSession: "₦580,000",
        category: "Master's",
        description: "Specialised executive master's focused on public financial management, policy design, government procurement, and ethical governance.",
        requirements: "A good first degree in any discipline with at least 3 years in public sector MDAs, NGOs, or development organisations."
      },
      {
        id: "p-dip-pa",
        degree: "Prof. Diploma",
        name: "Professional Diploma in Public Administration",
        duration: "12 Months",
        mode: "Weekend Sessions",
        feePerSession: "₦250,000",
        category: "Diploma",
        description: "Structured diploma covering modern administrative jurisprudence, public sector budgeting, and personnel management.",
        requirements: "Recognised National Diploma, NCE, or equivalent with 5 SSCE credits."
      },
      {
        id: "p-cert-pa",
        degree: "Prof. Cert",
        name: "Professional Certificate in Public Administration",
        duration: "6 Months",
        mode: "Modular Workshops",
        feePerSession: "₦150,000",
        category: "Certificate",
        description: "Hands-on certification in public records management, official protocol, and administrative correspondence.",
        requirements: "SSCE credit passes and employment in public or civil service."
      }
    ]
  },
  {
    id: "accounting-finance",
    name: "Accounting and Finance",
    description: "Corporate financial engineering, forensic accounting, auditing standards, taxation policy, and capital markets.",
    programmes: [
      {
        id: "phd-af",
        degree: "Doctorate",
        name: "Doctor of Accounting and Finance",
        duration: "3 - 5 Years",
        mode: "Advanced Financial Econometrics & Research",
        feePerSession: "₦920,000",
        category: "Doctoral",
        description: "Premier doctoral programme investigating contemporary financial market dynamics, international taxation, and corporate disclosure.",
        requirements: "Master's degree in Accounting, Banking, or Finance with minimum 60% average or equivalent."
      },
      {
        id: "emaf",
        degree: "EMAF",
        name: "Executive Master of Accounting and Finance",
        duration: "18 Months",
        mode: "Weekend Intensive & Practical Labs",
        feePerSession: "₦590,000",
        category: "Master's",
        description: "Designed in alignment with ICAN/CITN benchmarks for Chief Financial Officers, audit managers, and investment bankers.",
        requirements: "Recognised first degree or professional qualification (ACA, ACCA, ACIB, ACTI) with 3+ years finance experience."
      },
      {
        id: "p-dip-af",
        degree: "Prof. Diploma",
        name: "Professional Diploma in Accounting and Finance",
        duration: "12 Months",
        mode: "Weekend Classes",
        feePerSession: "₦260,000",
        category: "Diploma",
        description: "Foundational mastery in financial reporting standards (IFRS), tax management, and computerized accounting software.",
        requirements: "National Diploma, HND or SSCE with relevant accounting credits."
      },
      {
        id: "p-cert-af",
        degree: "Prof. Cert",
        name: "Professional Certificate in Accounting and Finance",
        duration: "6 Months",
        mode: "Modular Labs",
        feePerSession: "₦160,000",
        category: "Certificate",
        description: "Intensive training in payroll computation, treasury management, and audit inspection essentials.",
        requirements: "SSCE credits and basic quantitative aptitude."
      }
    ]
  }
];

// 4 DEMO STUDENTS (PhD, DBA, MBA, PGD) - ALL ASSUMED TO JUST START THEIR PROGRAMMES (TERM 1 / FRESH INTAKE)
// DBA incorporates the exact curriculum matrix from the institutional plan:
// T1: DBA 801 (3 Credits), T2: DBA 802 (6 Credits), T3: DBA 803 (6 Credits), T6: DBA 804 (3 Credits), T7: DBA 899 (36 Credits) = 54 Credits Total
export const DEMO_STUDENTS = [
  {
    id: "student-dba",
    programmeId: "dba",
    programmeName: "Doctor of Business Administration (DBA)",
    degreeLevel: "DBA",
    department: "Business Administration",
    fullName: "Emem Udoh",
    title: "Mr",
    gender: "Male",
    matricNo: "AKSU/BS/2026/DBA/012",
    email: "e.udoh@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. Asuquo E. Johnson, PhD",
    advisor: "Dr Uwem Etim Uwah, PhD, FCA",
    researchTopic: "Evaluating Strategic Agility and Operational Resilience in Downstream Petroleum Logistics: An Akwa Ibom Corridor Case Study",
    researchStage: "Stage 1: Topic Conceptualisation & Philosophical Grounding",
    currentTerm: "Term 1 (T1), 2026/2027 Session",
    status: "Newly Matriculated • Term 1 Commencing",
    cgpa: "Not Computed (First Term)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 3,
    totalCredits: 54,
    overallProgress: 3, // Just started!
    // EXACT "YOUR PLAN" TABLE AS SPECIFIED IN CURRICULUM BLUEPRINT
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Slot 1",
        code: "DBA 801",
        course: "DBA 801: Introduction to Research Philosophies and Paradigms",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Prof. Asuquo E. Johnson, PhD",
        schedule: "Saturdays 09:00 - 12:00 (Executive Boardroom & Virtual Studio)"
      },
      {
        unit: "T2",
        slot: "Slot 1",
        code: "DBA 802",
        course: "DBA 802: Analytic Techniques",
        credits: 6,
        status: "Upcoming (Term 2)",
        statusType: "upcoming",
        progress: 0,
        lecturer: "Dr O. T. Matthew, PhD, FSS",
        schedule: "Term 2 Scheduled Intake"
      },
      {
        unit: "T3",
        slot: "Slot 1",
        code: "DBA 803",
        course: "DBA 803: Practicum in Business Administration (T3 to T5)",
        credits: 6,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Executive Industry Mentorship Board",
        schedule: "Terms 3 to 5 Practicum Placement"
      },
      {
        unit: "T6",
        slot: "Slot 1",
        code: "DBA 804",
        course: "DBA 804: Academic Writing and Seminar Presentation",
        credits: 3,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Doctoral Review Panel",
        schedule: "Term 6 Seminar & Colloquium"
      },
      {
        unit: "T7",
        slot: "Slot 1",
        code: "DBA 899",
        course: "DBA 899: Dissertation (T7 to T18)",
        credits: 36,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Doctoral Supervisory Committee",
        schedule: "Terms 7 to 18 Applied Research & Viva Voce Defence"
      }
    ],
    // ACTIVE ENROLLED MODULE DETAIL FOR THE LMS DIGITAL CLASSROOM
    activeModule: {
      code: "DBA 801",
      title: "Introduction to Research Philosophies and Paradigms",
      units: 3,
      lecturer: "Prof. Asuquo E. Johnson, PhD",
      coLecturer: "Dr Uwem Etim Uwah, PhD, FCA",
      progress: 15,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Executive Suite 1, Main Campus Ikot Akpaden & Hybrid Stream)",
      materialsCount: 6,
      overview: "Philosophical foundations of executive business research, epistemological stances (positivism, interpretivism, pragmatism, critical realism), ontology, axiology, and translating industry challenges into defensible academic problems.",
      lessons: [
        {
          id: "les-1",
          number: "Lesson 1",
          title: "Foundations of Scientific Inquiry and the Nature of Knowledge",
          duration: "45 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Understanding the distinction between management opinion and rigorous empirical evidence in executive practice.",
          facilitator: {
            id: "fac-johnson",
            name: "Prof. Asuquo E. Johnson, PhD",
            rank: "Lead Professor of Strategic Management & Research Methodology",
            qualifications: "B.Sc, MBA, Ph.D, FNIM",
            email: "a.johnson@faculty.aksu.edu.ng",
            phone: "+234 803 721 9840",
            avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=300&auto=format&fit=crop",
            office: "Faculty Suite 4B, Senate Academic Wing, Ikot Akpaden",
            consultationHours: "Thursdays 14:00 - 17:00 & Saturdays Post-Seminar",
            status: "Online • Facilitator in Chambers",
            unreadFeedbackCount: 1
          }
        },
        {
          id: "les-2",
          number: "Lesson 2",
          title: "Ontological Positions: Realism, Nominalism, and Social Constructionism",
          duration: "55 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 15,
          keyTakeaway: "Investigating what constitutes reality in organizational systems and business strategy.",
          facilitator: {
            id: "fac-uwah",
            name: "Dr Uwem Etim Uwah, PhD, FCA, ACTI",
            rank: "Acting Director / Associate Professor of Accounting & Corporate Governance",
            qualifications: "B.Sc, M.Sc, PhD, FCA, ACTI",
            email: "uwemuwah@aksu.edu.ng",
            phone: "+234 803 338 0401",
            avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=300&auto=format&fit=crop",
            office: "Directorate Suite 1, Executive Wing, Ikot Akpaden",
            consultationHours: "Fridays 10:00 - 13:00",
            status: "Online • Directorate Desk Active",
            unreadFeedbackCount: 2
          }
        },
        {
          id: "les-3",
          number: "Lesson 3",
          title: "Epistemological Paradigms: Positivism vs. Interpretivism in Business",
          duration: "60 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 35,
          keyTakeaway: "Comparing objective hypothesis testing with subjective qualitative inquiry in high-stakes corporate contexts.",
          facilitator: {
            id: "fac-ntuen",
            name: "Prof. Celestine A. Ntuen, PhD, FIIE",
            rank: "Distinguished Professor of Quantitative Systems & Analytics",
            qualifications: "B.Sc, M.Sc, PhD, FIIE",
            email: "c.ntuen@faculty.aksu.edu.ng",
            phone: "+234 802 445 1199",
            avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=300&auto=format&fit=crop",
            office: "Faculty Suite 3C, Main Campus, Ikot Akpaden",
            consultationHours: "Wednesdays 11:00 - 14:00",
            status: "Available for Consultations",
            unreadFeedbackCount: 0
          }
        },
        {
          id: "les-4",
          number: "Lesson 4",
          title: "Pragmatism & Critical Realism: The Executive Researcher's Stance",
          duration: "50 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 60,
          keyTakeaway: "How executive doctorates bridge theoretical rigor with actionable practitioner transformation.",
          facilitator: {
            id: "fac-ekong-d",
            name: "Dr Donald I. Ekong, PhD, MNIM",
            rank: "Associate Professor of Organizational Systems & Governance",
            qualifications: "B.Sc, MBA, PhD, MNIM",
            email: "d.ekong@faculty.aksu.edu.ng",
            phone: "+234 803 556 7821",
            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=300&auto=format&fit=crop",
            office: "Faculty Suite 1E, Executive Wing, Ikot Akpaden",
            consultationHours: "Mondays 14:00 - 17:00",
            status: "Online • Research Lab Desk",
            unreadFeedbackCount: 0
          }
        },
        {
          id: "les-5",
          number: "Lesson 5",
          title: "Methodological Choice: The Saunders Research Onion Framework",
          duration: "75 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 85,
          keyTakeaway: "Peeling the research onion from philosophy and approach to strategy, choices, time horizons, and techniques.",
          facilitator: {
            id: "fac-udoh-a",
            name: "Dr (Mrs.) Anietie B. Udoh, PhD, FCIB",
            rank: "Senior Lecturer in Banking, Business Finance & Research Inquiry",
            qualifications: "B.Sc, M.Sc, PhD, FCIB",
            email: "a.udoh@faculty.aksu.edu.ng",
            phone: "+234 806 889 2314",
            avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=300&auto=format&fit=crop",
            office: "Faculty Suite 2B, Main Campus, Ikot Akpaden",
            consultationHours: "Thursdays 10:00 - 13:00",
            status: "Available for Consultations",
            unreadFeedbackCount: 0
          }
        },
        {
          id: "les-6",
          number: "Lesson 6",
          title: "Formulating Defensible Practitioner Research Questions & Conceptual Models",
          duration: "50 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 110,
          keyTakeaway: "Structuring problem statements that satisfy academic rigour and boardroom relevance.",
          facilitator: {
            id: "fac-akpan",
            name: "Prof. Bassey E. Akpan, PhD, FNIMN",
            rank: "Professor of Corporate Strategy & International Enterprise",
            qualifications: "B.Sc, M.Sc, PhD, FNIMN",
            email: "b.akpan@faculty.aksu.edu.ng",
            phone: "+234 803 667 4410",
            avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=300&auto=format&fit=crop",
            office: "Faculty Suite 5A, Senate Building, Ikot Akpaden",
            consultationHours: "Saturdays 13:00 - 15:30",
            status: "Online • Facilitator Available",
            unreadFeedbackCount: 0
          }
        }
      ],
      materials: [
        {
          title: "DBA 801 Course Handbook & Term 1 Study Guide",
          type: "PDF Document",
          size: "3.4 MB",
          category: "Syllabus & Curriculum"
        },
        {
          title: "Saunders Research Onion Master Diagram & Annotated Reference Chart",
          type: "PDF Document",
          size: "2.1 MB",
          category: "Framework"
        },
        {
          title: "Harvard Business Review: Rigor vs. Relevance in Management Inquiry",
          type: "Case Packet",
          size: "4.5 MB",
          category: "Reading Material"
        },
        {
          title: "AKSU Postgraduate Style Guide & Academic Integrity Code 2026",
          type: "Official Policy",
          size: "1.9 MB",
          category: "Governance"
        }
      ],
      assignments: [
        {
          id: "asg-1",
          title: "Continuous Assessment 1: Philosophical Grounding Matrix",
          brief: "Articulate your proposed doctoral research dilemma. Complete an ontological, epistemological, and axiological positioning matrix comparing how a Positivist versus an Interpretivist would investigate your topic.",
          dueDate: "31st October 2026 (11:59 PM)",
          status: "Drafting (In Progress)",
          weight: "30% of Term 1 Grade",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "DBA 801",
        title: "Introduction to Research Philosophies and Paradigms",
        units: 3,
        lecturer: "Prof. Asuquo E. Johnson, PhD",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 09:00 - 12:00 (Executive Suite 1)",
        materialsCount: 6,
        assignments: [
          { title: "Continuous Assessment 1: Philosophical Grounding Matrix", status: "Due 31 Oct", score: "Pending" }
        ],
        overview: "Philosophical foundations of executive business research, epistemological stances (positivism, interpretivism, pragmatism, critical realism), ontology, axiology, and translating industry challenges into defensible academic problems."
      }
    ]
  },
  {
    id: "student-phd",
    programmeId: "phd-ba",
    programmeName: "Doctor of Philosophy (PhD) in Business Administration",
    degreeLevel: "PhD",
    department: "Business Administration",
    fullName: "Idorenyin Bassey",
    title: "Mrs",
    gender: "Female",
    matricNo: "AKSU/BS/2026/PHD/004",
    email: "i.bassey@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=300&auto=format&fit=crop",
    supervisor: "Prof. N. A. Udoka, Ph.D, FNIM",
    advisor: "Dr Uwem Etim Uwah, PhD, FCA",
    researchTopic: "Digital Financial Inclusion, Institutional Trust, and SME Sustainability in the Niger Delta Region",
    researchStage: "Stage 1: Doctoral Concept Formulation & Literature Scoping",
    currentTerm: "Term 1 (T1), 2026/2027 Session",
    status: "Newly Matriculated • Term 1 Commencing",
    cgpa: "Not Computed (First Term)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 3,
    totalCredits: 54,
    overallProgress: 2,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Slot 1",
        code: "BUS 901",
        course: "BUS 901: Advanced Research Philosophies and Epistemology",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Prof. N. A. Udoka, PhD",
        schedule: "Saturdays 09:00 - 12:00 (Doctoral Theatre A)"
      },
      {
        unit: "T2",
        slot: "Slot 1",
        code: "BUS 902",
        course: "BUS 902: Advanced Qualitative Inquiry & Grounded Theory",
        credits: 6,
        status: "Upcoming (Term 2)",
        statusType: "upcoming",
        progress: 0,
        lecturer: "Prof. E. E. Akpan, PhD",
        schedule: "Term 2 Scheduled Intake"
      },
      {
        unit: "T3",
        slot: "Slot 1",
        code: "BUS 903",
        course: "BUS 903: Advanced Econometric Modelling & PLS-SEM (T3 to T5)",
        credits: 6,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Dr O. T. Matthew, PhD, FSS",
        schedule: "Terms 3 to 5 Econometric Lab"
      },
      {
        unit: "T6",
        slot: "Slot 1",
        code: "BUS 904",
        course: "BUS 904: Academic Writing, Seminar and Defence Colloquium",
        credits: 3,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Doctoral Board of Examiners",
        schedule: "Term 6 Colloquium & Oral Defense"
      },
      {
        unit: "T7",
        slot: "Slot 1",
        code: "BUS 999",
        course: "BUS 999: Doctoral Thesis Research & Viva Voce (T7 to T18)",
        credits: 36,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Supervisory Board",
        schedule: "Terms 7 to 18 Empirical Investigation & Viva Voce"
      }
    ],
    activeModule: {
      code: "BUS 901",
      title: "Advanced Research Philosophies and Epistemology",
      units: 3,
      lecturer: "Prof. N. A. Udoka, PhD",
      coLecturer: "Prof. Asuquo E. Johnson, PhD",
      progress: 10,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Doctoral Theatre A)",
      materialsCount: 5,
      overview: "Deep foundational study into epistemological and ontological paradigms underpinning social science inquiry, phenomenology, critical theory, hermeneutics, and theoretical model conceptualisation.",
      lessons: [
        {
          id: "phd-les-1",
          number: "Lesson 1",
          title: "The Epistemological Horizon of Business Administration",
          duration: "50 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Tracing knowledge claims from classical Greek logic to modern management paradigms."
        },
        {
          id: "phd-les-2",
          number: "Lesson 2",
          title: "Scientific Realism, Relativism, and Post-Positivist Critiques",
          duration: "65 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Critique of pure empiricism in institutional and organizational settings."
        },
        {
          id: "phd-les-3",
          number: "Lesson 3",
          title: "Constructing Conceptual Frameworks from Competing Theories",
          duration: "60 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 45,
          keyTakeaway: "Integrating agency theory, resource-based view, and institutional theory."
        }
      ],
      materials: [
        {
          title: "BUS 901 Advanced Epistemological Reader (Volume 1)",
          type: "PDF Document",
          size: "5.8 MB",
          category: "Course Reader"
        },
        {
          title: "Guidelines for Doctoral Thesis Conceptualisation (AKSU Senate)",
          type: "Senate Policy",
          size: "2.3 MB",
          category: "Regulations"
        }
      ],
      assignments: [
        {
          id: "asg-phd-1",
          title: "Epistemological Critique of Institutional Trust Literature",
          brief: "Critically evaluate three foundational epistemological perspectives on institutional trust in developing economic contexts.",
          dueDate: "2nd November 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "BUS 901",
        title: "Advanced Research Philosophies and Epistemology",
        units: 3,
        lecturer: "Prof. N. A. Udoka, PhD",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 09:00 - 12:00 (Doctoral Theatre A)",
        materialsCount: 5,
        assignments: [
          { title: "Epistemological Critique of Institutional Trust Literature", status: "Due 2 Nov", score: "Pending" }
        ],
        overview: "Deep foundational study into epistemological and ontological paradigms underpinning social science inquiry, phenomenology, critical theory, and theoretical model conceptualisation."
      }
    ]
  },
  {
    id: "student-mba",
    programmeId: "mba",
    programmeName: "Master of Business Administration (MBA)",
    degreeLevel: "MBA",
    department: "Business Administration",
    fullName: "Aniefiok Okon",
    title: "Mr",
    gender: "Male",
    matricNo: "AKSU/BS/2026/MBA/089",
    email: "a.okon@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=300&auto=format&fit=crop",
    supervisor: "Dr Grace M. Ekong, PhD",
    advisor: "Dr Uwem Etim Uwah, PhD, FCA",
    researchTopic: "Consumer Brand Loyalty and Digital Engagement in the Nigerian Retail Banking Sector",
    researchStage: "Term 1 Executive Foundation",
    currentTerm: "Term 1 (T1), 2026/2027 Session",
    status: "Newly Matriculated • Term 1 Commencing",
    cgpa: "Not Computed (First Term)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 6,
    totalCredits: 36,
    overallProgress: 4,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Slot 1",
        code: "MBA 801",
        course: "MBA 801: Managerial Economics & Price Strategy",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 14,
        lecturer: "Dr S. U. Udoh, PhD",
        schedule: "Saturdays 08:30 - 11:30 (Amphitheatre A)"
      },
      {
        unit: "T1",
        slot: "Slot 2",
        code: "MBA 802",
        course: "MBA 802: Financial Accounting for Executive Decision Making",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Dr Uwem Etim Uwah, PhD, FCA",
        schedule: "Saturdays 12:30 - 15:30 (Amphitheatre A)"
      },
      {
        unit: "T2",
        slot: "Slot 1",
        code: "MBA 803",
        course: "MBA 803: Corporate Financial Management & Valuation",
        credits: 3,
        status: "Upcoming (Term 2)",
        statusType: "upcoming",
        progress: 0,
        lecturer: "Dr Uwem Etim Uwah, PhD, FCA",
        schedule: "Term 2 Scheduled Intake"
      },
      {
        unit: "T2",
        slot: "Slot 2",
        code: "MBA 804",
        course: "MBA 804: Strategic Marketing & Omnichannel Brand Leadership",
        credits: 3,
        status: "Upcoming (Term 2)",
        statusType: "upcoming",
        progress: 0,
        lecturer: "Dr Grace M. Ekong, PhD",
        schedule: "Term 2 Scheduled Intake"
      },
      {
        unit: "T3",
        slot: "Slot 1",
        code: "MBA 805",
        course: "MBA 805: Operations Strategy & Technology Systems",
        credits: 3,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Engr. Dr B. C. Okon, PhD",
        schedule: "Term 3 Intake"
      },
      {
        unit: "T4",
        slot: "Slot 1",
        code: "MBA 890",
        course: "MBA 890: Applied Executive Capstone Consulting Project",
        credits: 12,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Faculty Executive Board",
        schedule: "Term 4 Final Project"
      }
    ],
    activeModule: {
      code: "MBA 801",
      title: "Managerial Economics & Price Strategy",
      units: 3,
      lecturer: "Dr S. U. Udoh, PhD",
      coLecturer: "Dr Uwem Etim Uwah, PhD, FCA",
      progress: 14,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 08:30 - 11:30 (Amphitheatre A & Virtual Studio)",
      materialsCount: 5,
      overview: "Microeconomic optimization, supply/demand elasticity, market structures, price discrimination models, and macroeconomic risk forecasting for business leadership.",
      lessons: [
        {
          id: "mba-les-1",
          number: "Lesson 1",
          title: "Microeconomic Decision Principles for C-Suite Executives",
          duration: "45 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Marginal analysis and opportunity cost in capital allocation."
        },
        {
          id: "mba-les-2",
          number: "Lesson 2",
          title: "Demand Elasticity, Dynamic Pricing, and Revenue Maximization",
          duration: "55 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Pricing power in volatile emerging markets with high inflation."
        },
        {
          id: "mba-les-3",
          number: "Lesson 3",
          title: "Market Structures: Monopoly, Oligopoly, and Competitive Moats",
          duration: "60 mins",
          status: "Upcoming",
          completed: false,
          videoTimestamp: 45,
          keyTakeaway: "Game theory and cartel stability in telecommunications and energy."
        }
      ],
      materials: [
        {
          title: "MBA 801 Lecture Slides & Pricing Frameworks",
          type: "Slide Deck",
          size: "4.1 MB",
          category: "Lecture Notes"
        },
        {
          title: "Case Study: Fast-Moving Consumer Goods Pricing in Nigeria",
          type: "Case Packet",
          size: "2.8 MB",
          category: "Reading Material"
        }
      ],
      assignments: [
        {
          id: "asg-mba-1",
          title: "Elasticity & Pricing Strategy for Fast-Moving Consumer Goods",
          brief: "Analyse cross-price and income elasticity of demand for a selected FMCG product line in Southern Nigeria amidst currency fluctuations.",
          dueDate: "28th October 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "MBA 801",
        title: "Managerial Economics & Price Strategy",
        units: 3,
        lecturer: "Dr S. U. Udoh, PhD",
        progress: 14,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 08:30 - 11:30 (Amphitheatre A)",
        materialsCount: 5,
        assignments: [
          { title: "Elasticity & Pricing Strategy for Fast-Moving Consumer Goods", status: "Due 28 Oct", score: "Pending" }
        ],
        overview: "Microeconomic optimization, supply/demand elasticity, market structures, price discrimination models, and macroeconomic risk forecasting."
      },
      {
        code: "MBA 802",
        title: "Financial Accounting for Executive Decision Making",
        units: 3,
        lecturer: "Dr Uwem Etim Uwah, PhD, FCA",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 12:30 - 15:30 (Amphitheatre A)",
        materialsCount: 4,
        assignments: [
          { title: "Financial Statement Diagnostic & Ratio Audit", status: "Due 4 Nov", score: "Pending" }
        ],
        overview: "Executive interpretation of financial statements, balance sheet health analysis, cash flow adequacy, and earnings quality evaluation."
      }
    ]
  },
  {
    id: "student-pgd",
    programmeId: "pgd-ba",
    programmeName: "Postgraduate Diploma in Business Administration (PGD)",
    degreeLevel: "PGD",
    department: "Business Administration",
    fullName: "Iniobong Akpan",
    title: "Ms",
    gender: "Female",
    matricNo: "AKSU/BS/2026/PGD/142",
    email: "i.akpan@student.aksu.edu.ng",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=300&auto=format&fit=crop",
    supervisor: "Dr M. E. Eteidung, PhD",
    advisor: "Dr Uwem Etim Uwah, PhD, FCA",
    researchTopic: "Inventory Management Systems and Operational Efficiency in Small and Medium Enterprises",
    researchStage: "Term 1 Foundation Courses",
    currentTerm: "Term 1 (T1), 2026/2027 Session",
    status: "Newly Matriculated • Term 1 Commencing",
    cgpa: "Not Computed (First Term)",
    attendanceRate: 100,
    completedCredits: 0,
    enrolledCredits: 6,
    totalCredits: 24,
    overallProgress: 5,
    curriculumPlan: [
      {
        unit: "T1",
        slot: "Slot 1",
        code: "PGD 701",
        course: "PGD 701: Principles & Foundations of Modern Management",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 15,
        lecturer: "Dr M. E. Eteidung, PhD",
        schedule: "Saturdays 09:00 - 12:00 (Hall C-1)"
      },
      {
        unit: "T1",
        slot: "Slot 2",
        code: "PGD 702",
        course: "PGD 702: Financial Accounting & Business Records",
        credits: 3,
        status: "In Progress",
        statusType: "current",
        progress: 10,
        lecturer: "Mr E. A. Asuquo, M.Sc, ACA",
        schedule: "Saturdays 13:00 - 16:00 (Hall C-1)"
      },
      {
        unit: "T2",
        slot: "Slot 1",
        code: "PGD 703",
        course: "PGD 703: Corporate Governance, Legal Frameworks & Ethics",
        credits: 3,
        status: "Upcoming (Term 2)",
        statusType: "upcoming",
        progress: 0,
        lecturer: "Barr. A. J. Udom, LL.M",
        schedule: "Term 2 Scheduled Intake"
      },
      {
        unit: "T2",
        slot: "Slot 2",
        code: "PGD 704",
        course: "PGD 704: Quantitative Techniques & Business Statistics",
        credits: 3,
        status: "Upcoming (Term 2)",
        statusType: "upcoming",
        progress: 0,
        lecturer: "Dr E. B. Williams, PhD",
        schedule: "Term 2 Scheduled Intake"
      },
      {
        unit: "T3",
        slot: "Slot 1",
        code: "PGD 790",
        course: "PGD 790: Applied Management Field Project & Technical Report",
        credits: 6,
        status: "Locked",
        statusType: "locked",
        progress: 0,
        lecturer: "Academic Supervisor Panel",
        schedule: "Term 3 Applied Capstone"
      }
    ],
    activeModule: {
      code: "PGD 701",
      title: "Principles & Foundations of Modern Management",
      units: 3,
      lecturer: "Dr M. E. Eteidung, PhD",
      coLecturer: "Prof. Asuquo E. Johnson, PhD",
      progress: 15,
      grade: "Continuous Assessment Active",
      status: "In Progress (Week 2 of 12)",
      schedule: "Saturdays 09:00 - 12:00 (Hall C-1 & Virtual Studio)",
      materialsCount: 4,
      overview: "Classical and contemporary management theories, POSDCORB principles, organizational design, modern managerial roles, and corporate goal alignment.",
      lessons: [
        {
          id: "pgd-les-1",
          number: "Lesson 1",
          title: "Evolution of Management Thought from Taylor to Mintzberg",
          duration: "40 mins",
          status: "Completed",
          completed: true,
          videoTimestamp: 0,
          keyTakeaway: "Understanding classical scientific management vs human relations movements."
        },
        {
          id: "pgd-les-2",
          number: "Lesson 2",
          title: "The Modern Managerial Function: Planning & Strategic Direction",
          duration: "50 mins",
          status: "In Progress",
          completed: false,
          current: true,
          videoTimestamp: 20,
          keyTakeaway: "Setting verifiable enterprise objectives and SWOT strategic alignment."
        }
      ],
      materials: [
        {
          title: "PGD 701 Study Module & Lecture Notes",
          type: "PDF Document",
          size: "3.2 MB",
          category: "Course Material"
        }
      ],
      assignments: [
        {
          id: "asg-pgd-1",
          title: "Comparative Review of Classical and Human Relations Management",
          brief: "Compare Taylor's Scientific Management with Mayo's Hawthorne Experiments in the context of contemporary workplace productivity.",
          dueDate: "29th October 2026",
          status: "Drafting",
          weight: "30% Continuous Assessment",
          submitted: false
        }
      ]
    },
    modules: [
      {
        code: "PGD 701",
        title: "Principles & Foundations of Modern Management",
        units: 3,
        lecturer: "Dr M. E. Eteidung, PhD",
        progress: 15,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 09:00 - 12:00 (Hall C-1)",
        materialsCount: 4,
        assignments: [
          { title: "Comparative Review of Classical and Human Relations Management", status: "Due 29 Oct", score: "Pending" }
        ],
        overview: "Classical and contemporary management theories, POSDCORB principles, organizational design, and managerial leadership."
      },
      {
        code: "PGD 702",
        title: "Financial Accounting & Business Records",
        units: 3,
        lecturer: "Mr E. A. Asuquo, M.Sc, ACA",
        progress: 10,
        grade: "In Progress",
        status: "In Progress",
        schedule: "Saturdays 13:00 - 16:00 (Hall C-1)",
        materialsCount: 3,
        assignments: [
          { title: "Trial Balance and Double-Entry Reconciliation Ledger", status: "Due 5 Nov", score: "Pending" }
        ],
        overview: "Double entry accounting principles, journal ledger posting, bank reconciliation statements, and preparation of basic trial balance."
      }
    ]
  }
];

// FACULTY DIRECTORY
export const FACULTY_MEMBERS = [
  {
    name: "Dr Uwem Etim Uwah",
    rank: "Acting Director / Associate Professor",
    qualifications: "PhD, FCA, ACTI",
    speciality: "Corporate Financial Reporting, Forensic Accounting & Strategic Auditing",
    email: "uwemuwah@aksu.edu.ng",
    coursesAssigned: ["BUS 907", "DBA 913", "MBA 803"],
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=300&auto=format&fit=crop"
  },
  {
    name: "Prof. Asuquo E. Johnson",
    rank: "Professor of Strategic Management",
    qualifications: "B.Sc, MBA, Ph.D, FNIM",
    speciality: "Enterprise Turnaround, Strategic Agility & Corporate Governance",
    email: "a.johnson@faculty.aksu.edu.ng",
    coursesAssigned: ["DBA 911", "BUS 905"],
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=300&auto=format&fit=crop"
  },
  {
    name: "Dr Grace M. Ekong",
    rank: "Senior Lecturer",
    qualifications: "B.Sc, M.Sc, PhD, MCIM",
    speciality: "Omnichannel Brand Strategy, Digital Marketing & Consumer Psychology",
    email: "g.ekong@faculty.aksu.edu.ng",
    coursesAssigned: ["MBA 805", "PGD 709"],
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=300&auto=format&fit=crop"
  },
  {
    name: "Prof. N. A. Udoka",
    rank: "Professor of Human Capital & Leadership",
    qualifications: "B.Sc, M.Sc, PhD, FIPM",
    speciality: "Leadership Dynamics, Strategic HR & High-Performance Teams",
    email: "n.udoka@faculty.aksu.edu.ng",
    coursesAssigned: ["BUS 901", "MBA 809"],
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=300&auto=format&fit=crop"
  }
];

// MODULE FACILITATORS DIRECTORY & HELPER
export const MODULE_FACILITATORS = [
  {
    id: "fac-johnson",
    name: "Prof. Asuquo E. Johnson, PhD",
    rank: "Lead Professor of Strategic Management & Research Methodology",
    qualifications: "B.Sc, MBA, Ph.D, FNIM",
    email: "a.johnson@faculty.aksu.edu.ng",
    phone: "+234 803 721 9840",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=300&auto=format&fit=crop",
    office: "Faculty Suite 4B, Senate Academic Wing, Ikot Akpaden",
    consultationHours: "Thursdays 14:00 - 17:00 & Saturdays Post-Seminar",
    status: "Online • Facilitator in Chambers",
    unreadFeedbackCount: 1
  },
  {
    id: "fac-uwah",
    name: "Dr Uwem Etim Uwah, PhD, FCA, ACTI",
    rank: "Acting Director / Associate Professor of Accounting & Corporate Governance",
    qualifications: "B.Sc, M.Sc, PhD, FCA, ACTI",
    email: "uwemuwah@aksu.edu.ng",
    phone: "+234 803 338 0401",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=300&auto=format&fit=crop",
    office: "Directorate Suite 1, Executive Wing, Ikot Akpaden",
    consultationHours: "Fridays 10:00 - 13:00",
    status: "Online • Directorate Desk Active",
    unreadFeedbackCount: 2
  },
  {
    id: "fac-ntuen",
    name: "Prof. Celestine A. Ntuen, PhD, FIIE",
    rank: "Distinguished Professor of Quantitative Systems & Analytics",
    qualifications: "B.Sc, M.Sc, PhD, FIIE",
    email: "c.ntuen@faculty.aksu.edu.ng",
    phone: "+234 802 445 1199",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=300&auto=format&fit=crop",
    office: "Faculty Suite 3C, Main Campus, Ikot Akpaden",
    consultationHours: "Wednesdays 11:00 - 14:00",
    status: "Available for Consultations",
    unreadFeedbackCount: 0
  },
  {
    id: "fac-ekong-d",
    name: "Dr Donald I. Ekong, PhD, MNIM",
    rank: "Associate Professor of Organizational Systems & Governance",
    qualifications: "B.Sc, MBA, PhD, MNIM",
    email: "d.ekong@faculty.aksu.edu.ng",
    phone: "+234 803 556 7821",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=300&auto=format&fit=crop",
    office: "Faculty Suite 1E, Executive Wing, Ikot Akpaden",
    consultationHours: "Mondays 14:00 - 17:00",
    status: "Online • Research Lab Desk",
    unreadFeedbackCount: 0
  },
  {
    id: "fac-udoh-a",
    name: "Dr (Mrs.) Anietie B. Udoh, PhD, FCIB",
    rank: "Senior Lecturer in Banking, Business Finance & Research Inquiry",
    qualifications: "B.Sc, M.Sc, PhD, FCIB",
    email: "a.udoh@faculty.aksu.edu.ng",
    phone: "+234 806 889 2314",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=300&auto=format&fit=crop",
    office: "Faculty Suite 2B, Main Campus, Ikot Akpaden",
    consultationHours: "Thursdays 10:00 - 13:00",
    status: "Available for Consultations",
    unreadFeedbackCount: 0
  },
  {
    id: "fac-akpan",
    name: "Prof. Bassey E. Akpan, PhD, FNIMN",
    rank: "Professor of Corporate Strategy & International Enterprise",
    qualifications: "B.Sc, M.Sc, PhD, FNIMN",
    email: "b.akpan@faculty.aksu.edu.ng",
    phone: "+234 803 667 4410",
    avatar: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=300&auto=format&fit=crop",
    office: "Faculty Suite 5A, Senate Building, Ikot Akpaden",
    consultationHours: "Saturdays 13:00 - 15:30",
    status: "Online • Facilitator Available",
    unreadFeedbackCount: 0
  }
];

export const getModuleFacilitator = (module, index = 0) => {
  if (module && module.facilitator) return module.facilitator;
  return MODULE_FACILITATORS[index % MODULE_FACILITATORS.length];
};

// LIVE ADMISSION SCREENING QUEUE (SIMULATION DATA)
export const INITIAL_APPLICANTS = [
  {
    applicationNo: "AKSU-BS-2026-APP-8841",
    fullName: "Obong Victor Okon",
    email: "v.okon@akwaenergy.com",
    phone: "+234 802 443 1120",
    programmeApplied: "Doctor of Business Administration (DBA)",
    category: "Doctoral",
    department: "Business Administration",
    qualifications: "M.Sc Business Administration (UNN, 4.40 CGPA), B.Sc Accounting (Uniuyo, 2:1)",
    workExperience: "14 Years (General Manager, Operations & Compliance at Atlantic Oilfield Logistics)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_998471203",
    paystackDate: "12 Oct 2026, 14:22",
    documents: [
      { name: "First Degree Certificate (B.Sc)", verified: true },
      { name: "Master's Degree Certificate (M.Sc)", verified: true },
      { name: "Official Academic Transcript", verified: true },
      { name: "Executive CV / Profile", verified: true },
      { name: "Research Intent Statement", verified: true }
    ],
    screeningScore: 92,
    screeningStatus: "Approved", // Approved, Pending, Conditional
    decisionDate: "15 Oct 2026",
    admissionLetterIssued: true,
    matricNo: "AKSU/BS/2026/DBA/019"
  },
  {
    applicationNo: "AKSU-BS-2026-APP-8842",
    fullName: "Blessing Eno Archibong",
    email: "blessing.archibong@firs.gov.ng",
    phone: "+234 803 991 7654",
    programmeApplied: "Executive Master of Accounting and Finance (EMAF)",
    category: "Master's",
    department: "Accounting and Finance",
    qualifications: "B.Sc Banking & Finance (AKSU, First Class Honours, 4.68 CGPA), ACA (In View)",
    workExperience: "6 Years (Senior Tax Auditor, Federal Inland Revenue Service)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_771923441",
    paystackDate: "14 Oct 2026, 10:15",
    documents: [
      { name: "Degree Certificate (B.Sc First Class)", verified: true },
      { name: "Academic Transcript", verified: true },
      { name: "Employer Sponsorship / Reference", verified: true },
      { name: "Curriculum Vitae", verified: true }
    ],
    screeningScore: 95,
    screeningStatus: "Approved",
    decisionDate: "16 Oct 2026",
    admissionLetterIssued: true,
    matricNo: "AKSU/BS/2026/EMAF/041"
  },
  {
    applicationNo: "AKSU-BS-2026-APP-8843",
    fullName: "Edidiong Sunday Essien",
    email: "e.essien@gov.ak.ng",
    phone: "+234 814 300 8912",
    programmeApplied: "Executive Master of Public Administration (EMPA)",
    category: "Master's",
    department: "Public Administration",
    qualifications: "B.Sc Political Science (Calabar, Second Class Upper)",
    workExperience: "9 Years (Principal Planning Officer, Akwa Ibom State Ministry of Economic Development)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_665421098",
    paystackDate: "16 Oct 2026, 09:40",
    documents: [
      { name: "Degree Certificate", verified: true },
      { name: "Academic Transcript", verified: false },
      { name: "Government Service Letter", verified: true }
    ],
    screeningScore: 84,
    screeningStatus: "Pending", // Awaiting transcript validation
    decisionDate: "Awaiting Review",
    admissionLetterIssued: false,
    matricNo: null
  },
  {
    applicationNo: "AKSU-BS-2026-APP-8844",
    fullName: "Kufre Mfoniso James",
    email: "kufre.james@gmail.com",
    phone: "+234 703 552 9011",
    programmeApplied: "Postgraduate Diploma in Business Administration (PGD)",
    category: "Postgraduate Diploma",
    department: "Business Administration",
    qualifications: "HND Business Administration (Heritage Polytechnic, Distinction)",
    workExperience: "4 Years (Branch Operations Supervisor, Zenith Bank Plc)",
    applicationFeePaid: true,
    paystackRef: "PSTK_LIVE_441290382",
    paystackDate: "17 Oct 2026, 16:05",
    documents: [
      { name: "HND Certificate (Distinction)", verified: true },
      { name: "Polytechnic Transcript", verified: true },
      { name: "NYSC Discharge Certificate", verified: true }
    ],
    screeningScore: 89,
    screeningStatus: "Approved",
    decisionDate: "18 Oct 2026",
    admissionLetterIssued: true,
    matricNo: "AKSU/BS/2026/PGD/148"
  }
];
